import React from "react";

const WarningIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_190_632"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20"
      >
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_190_632)">
        <path
          d="M10.4993 14.167C10.7355 14.167 10.9334 14.0871 11.0931 13.9274C11.2528 13.7677 11.3327 13.5698 11.3327 13.3337C11.3327 13.0975 11.2528 12.8996 11.0931 12.7399C10.9334 12.5802 10.7355 12.5003 10.4993 12.5003C10.2632 12.5003 10.0653 12.5802 9.9056 12.7399C9.74588 12.8996 9.66601 13.0975 9.66601 13.3337C9.66601 13.5698 9.74588 13.7677 9.9056 13.9274C10.0653 14.0871 10.2632 14.167 10.4993 14.167ZM10.4993 10.8337C10.7355 10.8337 10.9334 10.7538 11.0931 10.5941C11.2528 10.4344 11.3327 10.2364 11.3327 10.0003V6.66699C11.3327 6.43088 11.2528 6.23296 11.0931 6.07324C10.9334 5.91352 10.7355 5.83366 10.4993 5.83366C10.2632 5.83366 10.0653 5.91352 9.9056 6.07324C9.74588 6.23296 9.66601 6.43088 9.66601 6.66699V10.0003C9.66601 10.2364 9.74588 10.4344 9.9056 10.5941C10.0653 10.7538 10.2632 10.8337 10.4993 10.8337ZM10.4993 18.3337C9.34657 18.3337 8.26324 18.1149 7.24935 17.6774C6.23546 17.2399 5.35352 16.6462 4.60352 15.8962C3.85352 15.1462 3.25977 14.2642 2.82227 13.2503C2.38477 12.2364 2.16602 11.1531 2.16602 10.0003C2.16602 8.84755 2.38477 7.76421 2.82227 6.75032C3.25977 5.73644 3.85352 4.85449 4.60352 4.10449C5.35352 3.35449 6.23546 2.76074 7.24935 2.32324C8.26324 1.88574 9.34657 1.66699 10.4993 1.66699C11.6521 1.66699 12.7355 1.88574 13.7493 2.32324C14.7632 2.76074 15.6452 3.35449 16.3952 4.10449C17.1452 4.85449 17.7389 5.73644 18.1764 6.75032C18.6139 7.76421 18.8327 8.84755 18.8327 10.0003C18.8327 11.1531 18.6139 12.2364 18.1764 13.2503C17.7389 14.2642 17.1452 15.1462 16.3952 15.8962C15.6452 16.6462 14.7632 17.2399 13.7493 17.6774C12.7355 18.1149 11.6521 18.3337 10.4993 18.3337ZM10.4993 16.667C12.3605 16.667 13.9368 16.0212 15.2285 14.7295C16.5202 13.4378 17.166 11.8614 17.166 10.0003C17.166 8.13921 16.5202 6.56283 15.2285 5.27116C13.9368 3.97949 12.3605 3.33366 10.4993 3.33366C8.63824 3.33366 7.06185 3.97949 5.77018 5.27116C4.47852 6.56283 3.83268 8.13921 3.83268 10.0003C3.83268 11.8614 4.47852 13.4378 5.77018 14.7295C7.06185 16.0212 8.63824 16.667 10.4993 16.667Z"
          fill="#E77F16"
        />
      </g>
    </svg>
  );
};

export default WarningIcon;
